// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"688":"69602249","793":"25dc53eb"}[chunkId] + ".chunk.css";
};